import React from "react";
import Context from "../../../../Context";
import Blocker from "../../../Misc/Blocker";
import CrumbsProvider from "../../../Misc/CrumbsProvider";
import ObjectInspector from "react-object-inspector";

export default class ApiConsole extends React.Component {
  static contextType = Context;
  constructor(props) {
    super(props);
    this.state = {
      path: "",
      body: "",
      result: "",
      pending: false,
    };
  }

  send = async () => {
    this.setState({ pending: true });
    let body = this.state.body ? JSON.parse(this.state.body) : {};
    try {
      let result = await this.context.api.q(this.state.path, body);
      if (result !== false) {
        this.context.toast(`Запрос выполнен`, "success");
        this.setState({ result: JSON.stringify(result) });
      } else {
        this.context.toast(`Не удалось выполнить запрос`, "error");
      }
    } catch (e) {
      this.context.toast(e.message, "error");
    }
    this.setState({ pending: false });
  };

  sendWs = async () => {
    this.setState({ pending: true });
    let body = this.state.body ? JSON.parse(this.state.body) : {};
    try {
      this.context.ws.q(this.state.path, body);
    } catch (e) {
      this.context.toast(e.message, "error");
    }
    this.setState({ pending: false });
  };

  tokenExchange = async () => {
    this.context.api.token.exchange();
  };

  render() {
    return (
      <Blocker on={this.state.pending}>
        <CrumbsProvider title="Консоль API" />
        <div className="card card-custom gutter-b">
          <div className="card-body">
            <div className="row">
              <div className="col-lg-4 border-right">
                <div className="form-group">
                  <label>Путь</label>
                  <input
                    autoComplete="true"
                    className="form-control"
                    type="text"
                    value={this.state.path}
                    onChange={(e) => this.setState({ path: e.target.value })}
                    onKeyPress={(e) => {
                      if (e.key === "Enter") this.send();
                    }}
                  />
                </div>
                <div className="form-group">
                  <label>Тело запроса</label>
                  <textarea
                    className="form-control"
                    type="text"
                    value={this.state.body}
                    onChange={(e) => this.setState({ body: e.target.value })}
                  />
                </div>
                <button className="btn btn-light" onClick={this.send}>
                  Выполнить REST
                </button>
                <button className="btn btn-light ml-2" onClick={this.sendWs}>
                  Выполнить WS
                </button>
                <hr />
                <button className="btn btn-light" onClick={this.tokenExchange}>
                  Обменять токен
                </button>
              </div>
              <div className="col-lg-8">
                {this.state.result ? (
                  <ObjectInspector
                    data={JSON.parse(this.state.result || "{}")}
                    initialExpandedPaths={["root"]}
                  />
                ) : null}
              </div>
            </div>
          </div>
        </div>
      </Blocker>
    );
  }
}
